import { RecommendationClause } from './recommendation-clause';

export interface ExplanationValue {
 isValid(clauses : RecommendationClause[]): boolean;
 toShort() : any;
}

export class ExplanationShort {
  constructor(
    public type: string,
    public value: any
  ) {}
}

export class ExplanationFull {
  constructor(
    public type: string,
    public value?: ExplanationValue
  ) {}
  equals(other : ExplanationFull) : boolean {
    return this.type == other.type &&
      this.value == other.value;
  }
  isValid(clauses : RecommendationClause[]) : boolean {
    return this.type && this.value && this.value.isValid(clauses);
  }
}

export class ExplanationQuestionShort {
  constructor(
    public question_id : string,
    public answer_value : string,
    public text : string,
    public playlist_id? : string
  ) {}
}

export class ExplanationQuestionFull implements ExplanationValue {
  constructor(
    public question_id? : string,
    public answer_value? : string,
    public text? : string,
    public playlist_id? : string
  ) {}

  public isValid(clauses : RecommendationClause[]) : boolean {
    return this.question_id != null &&
      clauses.some(rc => rc.questions.some(q => q.id == this.question_id)) &&
      this.answer_value!= null && (
        this.answer_value != null || this.playlist_id != null
      );
  }
  public toShort() : any {
    return new ExplanationQuestionShort(this.question_id, this.answer_value, this.text, this.playlist_id);
  }
}

export class ExplanationTextFull implements ExplanationValue {
  constructor(
    public text? : string
 ) {}

  public isValid(clauses : RecommendationClause[]) : boolean {
    return this.text != null;
  }
  public toShort() : any {
    return this.text;
  }
}




// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/model/explanation.ts